/** @internal */ /** */
// This I18n class was based on
// https://github.azc.ext.hp.com/HPC-Client-Services/hpc-frontend/blob/05000292f4d882b8abbd7a9d5b9fe173afb33e8e/src/components/Dashboard/utils/i18n.js
// written by Mattheus Bauer.
// It has been modified for typescript compliance and some variable names changes.
/**
 * Finds occurrences of {{}} within the localized string and replaces it
 * with the corresponding value provided in the keys Record
 *
 * @param translatedString
 * @param keys
 */
function stringParser(translatedString, keys) {
    var templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
    return translatedString.replace(templateMatcher, function (substring, idx) { return keys[idx]; });
}
/**
 * Finds the localized string for the requested locale
 */
var I18n = /** @class */ (function () {
    /**
     *
     * @param localeToStringsJson Mapping of locales to a translated string json structure.  {@link LocaleToStringsJson Example}
     * @param localeCode <lowercase 2 letter Language Code (ISO 639-1 format)>_<uppercase Country Code (ISO 3166-1 alpha-2 format)>
     */
    function I18n(localeToStringsJson, localeCode) {
        this.localeToStringsJson = localeToStringsJson;
        // verify if we have a translation for the requested locale, if not get a fallback
        this.localeCode = localeToStringsJson[localeCode] ? localeCode : this.getFallback(localeCode);
    }
    /**
     * @param localeCode actual locale
     * @returns fallback locale
     */
    I18n.prototype.getFallback = function (localeCode) {
        // look for fallback for entire locales
        var fallbackLocale = fallbackLocaleCode(localeCode);
        if (this.localeToStringsJson[fallbackLocale]) {
            return fallbackLocale;
        }
        else {
            // look for fallback for languages
            fallbackLocale = fallbackLanguageCode(localeCode);
            if (this.localeToStringsJson[fallbackLocale]) {
                return fallbackLocale;
            }
            else {
                // no translation for the locale or fallback locale, just default to english
                return fallbackLanguageCode('en');
            }
        }
    };
    /**
     * @returns localeCode
     */
    I18n.prototype.getLocaleCode = function () {
        return this.localeCode;
    };
    /**
     *
     * @param textId The string to index within the locale's json
     * @param keys If the string contains interpolation {{}}, the interpolation placeholder will
     * be substituted with the corresponding value within the keys Record.
     * @returns The translated string or if its not found it will return the id it tried to look up.
     */
    I18n.prototype.t = function (id, keys) {
        var rawString = id.split('.').reduce(this.reducer, this.localeToStringsJson[this.localeCode]);
        if (typeof (rawString) === 'string') {
            if (typeof (keys) == 'undefined') {
                return rawString;
            }
            else {
                return stringParser(rawString, keys);
            }
        }
        return id;
    };
    /**
     *
     * @param accumulator The current json substructure that its being iterated through on each call or the final resulting string
     * @param currentValue The key to use as an index into the acumulator JSON
     */
    I18n.prototype.reducer = function (accumulator, currentValue) {
        if (typeof (accumulator) === 'string' || typeof (accumulator) == 'undefined') {
            return accumulator;
        }
        else {
            return accumulator[currentValue];
        }
    };
    return I18n;
}());
export { I18n };
/**
 * If the country specific languages was not found,
 * use fallbackLanguage to find the next best choice for that language.
 *
 * @param locale The requested locale based on the country and language.
 * @returns The closest configured fallback local for that language.
 */
function fallbackLanguageCode(locale) {
    var languages = {
        ar: 'ar_SA',
        bg: 'bg_BG',
        ca: 'ca_ES',
        cs: 'cs_CZ',
        da: 'da_DK',
        de: 'de_DE',
        el: 'el_GR',
        en: 'en_US',
        es: 'es_ES',
        et: 'et_EE',
        fi: 'fi_FI',
        fr: 'fr_FR',
        he: 'he_IL',
        hr: 'hr_HR',
        hu: 'hu_HU',
        id: 'id_ID',
        it: 'it_IT',
        ja: 'ja_JP',
        ko: 'ko_KR',
        lt: 'lt_LT',
        lv: 'lv_LV',
        nb: 'nb_NO',
        nl: 'nl_NL',
        no: 'nb_NO',
        pl: 'pl_PL',
        pt: 'pt_PT',
        ro: 'ro_RO',
        ru: 'ru_RU',
        sk: 'sk_SK',
        sl: 'sl_SI',
        sv: 'sv_SE',
        th: 'th_TH',
        tr: 'tr_TR',
        zh: 'zh_CN',
    };
    var localeCode = locale.substring(0, 2).toLowerCase();
    if (languages[localeCode]) {
        return languages[localeCode];
    }
    return locale;
}
/**
 * If the country specific languages was not found,
 * use fallbackLanguage to find the next best choice for that language.
 *
 * @param locale The requested locale based on the country and language.
 * @returns The closest configured fallback local for that language.
 */
function fallbackLocaleCode(locale) {
    var locales = {
        zh_HK: 'zh_TW' // Chinese Taiwan
    };
    if (locales[locale]) {
        return locales[locale];
    }
    return locale;
}
//# sourceMappingURL=i18n.js.map